import HCHome from './HCHome';
//If a module specifies a routes.js, it can export an object
//where the keys are the paths and the values are the components
// Register all routes at once using an object
export default {
    "/help-center/submit-request": HCHome,
    "/help-center*": HCHome
}